
const onboardingStepOneValidation = (values: any) => {
    const errors: { teamName?: string } = {};

    if (!values.teamName || !values.teamName.trim()) {
        errors.teamName = 'Obligatoriu';
    }

    return errors;
};

const onboardingStepTwoValidation = (values: any) => {
    const errors: {
        lastName?: string;
        firstName?: string;
        domicile?: string;
        street?: string;
        number?: string;
        block?: string;
        staircase?: string;
        floor?: string;
        apartment?: string;
        sector?: string;
        birthDate?: string;
        identityDocType?: string;
        identitySeries?: string;
        identityNumber?: string;
        cnp?: string;
        email?: string;
        phone?: string;
    } = {};

    if (!values.lastName || !values.lastName.trim()) {
        errors.lastName = 'Obligatoriu';
    }
    if (!values.firstName || !values.firstName.trim()) {
        errors.firstName = 'Obligatoriu';
    }
    if (!values.domicile || !values.domicile.trim()) {
        errors.domicile = 'Obligatoriu';
    }
    if (!values.street || !values.street.trim()) {
        errors.street = 'Obligatoriu';
    }
    if (!values.number || !values.number.trim()) {
        errors.number = 'Obligatoriu';
    }
    if (!values.block || !values.block.trim()) {
        errors.block = 'Obligatoriu';
    }
    if (!values.staircase || !values.staircase.trim()) {
        errors.staircase = 'Obligatoriu';
    }
    if (!values.floor || !values.floor.trim()) {
        errors.floor = 'Obligatoriu';
    }
    if (!values.apartment || !values.apartment.trim()) {
        errors.apartment = 'Obligatoriu';
    }
    if (!values.sector || !values.sector.trim()) {
        errors.sector = 'Obligatoriu';
    }
    if (!values.birthDate) {
        errors.birthDate = 'Obligatoriu';
    } else {
        const birth = new Date(values.birthDate);
        const today = new Date();
        let age = today.getFullYear() - birth.getFullYear();
        const monthDiff = today.getMonth() - birth.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        if (age < 18) {
            errors.birthDate = 'Participantul trebuie sa aiba cel putin 18 ani';
        }
    }
    if (!values.identityDocType) {
        errors.identityDocType = 'Obligatoriu';
    }
    if (!values.identitySeries || !values.identitySeries.trim()) {
        errors.identitySeries = 'Obligatoriu';
    }
    if (!values.identityNumber || !values.identityNumber.trim()) {
        errors.identityNumber = 'Obligatoriu';
    }
    if (!values.cnp || !values.cnp.trim()) {
        errors.cnp = 'Obligatoriu';
    } else if (values.cnp.trim().length !== 13) {
        errors.cnp = 'CNP-ul trebuie sa contina 13 cifre';
    }
    if (!values.email || !values.email.trim()) {
        errors.email = 'Obligatoriu';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = 'Adresa de email invalida';
    }
    if (!values.phone || !values.phone.trim()) {
        errors.phone = 'Obligatoriu';
    }

    return errors;
};

export { onboardingStepOneValidation, onboardingStepTwoValidation };
